import * as React from 'react';
import {styled, styledDiv, emotionStyled} from '@packages/utilities/styled';
import Hitarea from '../Hitarea';
import {Clickable} from '../logic/clickable';
import {fade} from '@packages/utilities/inline-style-utils';

const ButtonContainer = styledDiv(
  ({theme, accent, style}) => {
    let color = style?.color;

    if (!color) {
      color = accent ? theme.colors.accent : theme.colors.foregroundAlphaDim;
    }

    return {
      color,
      transition: 'color 0.1s ease',
    };
  },
  {
    hover: ({theme, accent}) => ({
      color: accent ? theme.colors.accentVivid : theme.colors.foreground,
    }),
    disabled: ({theme, accent}) => ({
      color: accent
        ? fade(0.65)(theme.colors.accentBackground)
        : theme.colors.foregroundDimmer,
    }),
  }
);

const ButtonMousedownTarget = styled(Clickable)(() => ({
  padding: 10,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));

const Wrapper = emotionStyled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});

type SVGButtonProps = {
  onKeyDown?: (arg1?: any) => void;
  onClick?: (arg1?: any) => void;
  icon: React.ReactElement<any>;
  accent?: boolean;
  disabled?: boolean | null;
  ['data-automation-id']?: string;
  allowGlobalEventHandlers?: boolean;
  ariaLabel?: string;
  style?: any;
  cursor?: string;
};

/**
 * @deprecated use `IconButton` from `@packages/systems/spring` instead
 */
const SVGButton = ({
  onKeyDown,
  onClick,
  icon,
  disabled,
  accent,
  'data-automation-id': dataAutomationId,

  // for keyboard shortcuts to work while the button is focused
  allowGlobalEventHandlers,

  ariaLabel,
  style,
  cursor = 'default',
}: SVGButtonProps) => {
  return (
    <Wrapper data-legacy-ds="SVGButton" style={style}>
      <Hitarea>
        <ButtonContainer disabled={disabled} accent={accent} style={style}>
          {icon}
          <ButtonMousedownTarget
            cursor={cursor}
            data-prevent-global-event-handlers={
              allowGlobalEventHandlers ? undefined : true
            }
            onClick={onClick}
            onKeyDown={onKeyDown}
            disabled={disabled}
            data-automation-id={dataAutomationId}
            aria-label={ariaLabel}
          />
        </ButtonContainer>
      </Hitarea>
    </Wrapper>
  );
};

export default React.memo<SVGButtonProps>(SVGButton);
